export default function Games() {
  const games = [
    {
      title: 'Fuck, Marry, Kill',
      description: 'Make impossible choices. Brutal. Hilarious.',
      icon: 'ri-heart-3-fill',
      gradient: 'from-purple-600 to-pink-600',
      bgGradient: 'from-purple-900/20 to-pink-900/20',
      borderColor: 'border-purple-500/20 hover:border-purple-500/40'
    },
    {
      title: 'Would You Rather',
      description: 'Ridiculous scenarios. Everyone must choose.Strong opinions guaranteed.',
      icon: 'ri-question-line',
      gradient: 'from-blue-600 to-cyan-600',
      bgGradient: 'from-blue-900/20 to-cyan-900/20',
      borderColor: 'border-blue-500/20 hover:border-blue-500/40'
    },
    {
      title: 'Most Likely To',
      description: 'Vote on who fits the description best.Point fingers and argue your case.',
      icon: 'ri-user-star-line',
      gradient: 'from-pink-600 to-purple-600',
      bgGradient: 'from-pink-900/20 to-purple-900/20',
      borderColor: 'border-pink-500/20 hover:border-pink-500/40'
    },
    {
      title: 'Tonight\'s Mission',
      description: 'Complete your mission without getting caught.',
      icon: 'ri-spy-line',
      gradient: 'from-cyan-600 to-blue-600',
      bgGradient: 'from-cyan-900/20 to-blue-900/20',
      borderColor: 'border-cyan-500/20 hover:border-cyan-500/40'
    },
    {
      title: 'Ice Breaker',
      description: 'Quick prompts to get everyone talking. Easy questions to warm up the room.',
      icon: 'ri-chat-smile-3-line',
      gradient: 'from-green-600 to-emerald-600',
      bgGradient: 'from-green-900/20 to-emerald-900/20',
      borderColor: 'border-green-500/20 hover:border-green-500/40'
    },
    {
      title: 'Never Have I Ever',
      description: 'Classic confessions, no drinks required. Simple statements. Honest reactions.',
      icon: 'ri-hand-heart-line',
      gradient: 'from-orange-600 to-red-600',
      bgGradient: 'from-orange-900/20 to-red-900/20',
      borderColor: 'border-orange-500/20 hover:border-orange-500/40'
    },
    {
      title: 'Smash or Pass?',
      description: 'Wild character traits. Instant reactions. Decide fast and defend it.',
      icon: 'ri-fire-line',
      gradient: 'from-red-600 to-pink-600',
      bgGradient: 'from-red-900/20 to-pink-900/20',
      borderColor: 'border-red-500/20 hover:border-red-500/40'
    },
    {
      title: 'Quiz',
      description: 'Test your knowledge and argue confidently. A focused reset for the group.',
      icon: 'ri-lightbulb-line',
      gradient: 'from-yellow-600 to-orange-600',
      bgGradient: 'from-yellow-900/20 to-orange-900/20',
      borderColor: 'border-yellow-500/20 hover:border-yellow-500/40'
    },
    {
      title: 'Truth or Dare?',
      description: 'Playful dares and revealing questions. Best saved for later.',
      icon: 'ri-flashlight-line',
      gradient: 'from-indigo-600 to-purple-600',
      bgGradient: 'from-indigo-900/20 to-purple-900/20',
      borderColor: 'border-indigo-500/20 hover:border-indigo-500/40'
    },
    {
      title: 'Charades',
      description: 'Act it out. No talking. Full commitment. Peak energy guaranteed.',
      icon: 'ri-emotion-laugh-line',
      gradient: 'from-teal-600 to-cyan-600',
      bgGradient: 'from-teal-900/20 to-cyan-900/20',
      borderColor: 'border-teal-500/20 hover:border-teal-500/40'
    }
  ];

  return (
    <section id="games" className="py-24 px-6 bg-gradient-to-b from-transparent to-purple-900/10">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-6" style={{ color: '#606FE5', lineHeight: '1.3' }}>
          Pick your game.
        </h2>
        
        <p className="text-lg text-gray-400 text-center mb-10">
          10+ live game modes. More added regularly.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {games.map((game, index) => (
            <div 
              key={index}
              className={`bg-gradient-to-br ${game.bgGradient} backdrop-blur-sm border ${game.borderColor} rounded-2xl p-6 transition-all hover:scale-105 min-h-[180px] flex flex-col`}
            >
              <div className={`w-14 h-14 flex items-center justify-center bg-gradient-to-br ${game.gradient} rounded-xl mb-4`}>
                <i className={`${game.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold mb-2">{game.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{game.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}